import * as bootstrap from 'bootstrap';

export function initializeTableRowModal() {
	const clickableRows = document.querySelectorAll('.row-details');

	if (!clickableRows) {
		return;
	}

	clickableRows.forEach(row => {

		row.addEventListener('click', function (e) {

			// Parse JSON data from payload
			const data = JSON.parse(this.dataset.payload);
			if (!data) {
				return;
			}

			const converted = data.converted ? data.converted.toLowerCase() === 'true' : false;

			// Populate modal fields with all payload data
			document.getElementById('modal-buyer-name').textContent = data.buyer_name || '';
			document.getElementById('modal-call-date').textContent = data.call_date || '';
			document.getElementById('modal-caller-id').textContent = data.caller_id || '';
			document.getElementById('modal-connected-call-length').textContent = data.connected_call_length || '';
			document.getElementById('modal-connected-length2').textContent = data.connected_call_length || '';
			document.getElementById('modal-converted').textContent = data.converted.toLowerCase() == 'true' ? 'Converted' : 'Not Converted';
			document.getElementById('modal-duration').textContent = data.duration || '';
			document.getElementById('modal-end-call-source').textContent = data.end_call_source || '';
			document.getElementById('modal-call-instance-id').textContent = data.call_instance_id || '';
			document.getElementById('modal-call-instance-id2').textContent = data.call_instance_id || '';
			document.querySelector('[data-acp-ciid]').setAttribute('data-acp-ciid', data.call_instance_id || '');
			document.getElementById('download-transcription').setAttribute('href', `/download_transcript/${data.client_id}/${data.pk}/`);
			document.getElementById('download-recording').setAttribute('href', data.recording || '#');
			document.getElementById('modal-inbound-number-state').textContent = data.inbound_number_state || '';
			document.getElementById('modal-is-duplicate').textContent = data.is_duplicate ? 'Yes' : 'No';
			document.getElementById('modal-cost').textContent = data.cost || '';
			document.getElementById('modal-data-source').textContent = data.data_source || '';
			document.getElementById('modal-target-name').textContent = data.target_name || '';
			document.getElementById('modal-target-sub-id').textContent = data.target_sub_id || '';
			document.getElementById('modal-time-to-call').textContent = data.time_to_call || '';
			document.getElementById('modal-time-to-connect').textContent = data.time_to_connect || '';
			document.getElementById('modal-vertical').textContent = data.vertical || '';
			document.getElementById('modal-zip-code').textContent = data.zip_code || '';
			document.getElementById('modal-zip-code2').textContent = data.zip_code || '';

			if(converted) {
				document.getElementById('modal-converted').classList.remove('text-red');
				document.getElementById('modal-converted').classList.add('text-green');
			} else {
				document.getElementById('modal-converted').classList.remove('text-green');
				document.getElementById('modal-converted').classList.add('text-red');
			}

			let score = data.score || 0;
			let score_bg_color_class = '#e879f9';
			if (score >= 40) {
				score_bg_color_class = '#246c52';
			} else if (score >= 20) {
				score_bg_color_class = '#9bc46b';
			}

			document.querySelector('#overall-score-value').textContent = `${data.score || 0}%`;
			document.querySelector('#overall-score-value').style.color = score_bg_color_class;

			// Populate accordion with questions
			const accordionContainer = document.getElementById('scorecardQuestions');
			accordionContainer.innerHTML = ''; // Clear existing accordion items

			if (data.questions && typeof data.questions === 'object') {
				Object.keys(data.questions).forEach((questionKey, index) => {
					const question = data.questions[questionKey];
					const accordionId = `collapse${index + 1}`;

					let percentage = question.max_score > 0 ? (question.score / question.max_score) * 100 : 0;
					percentage = Math.round(percentage * 100) / 100;

					const accordionItem = document.createElement('div');
					accordionItem.className = 'accordion-item';
					accordionItem.innerHTML = `
							<div class="score-item accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#${accordionId}" aria-expanded="false" aria-controls="${accordionId}">
									<p class="d-flex justify-content-between"><span class="score-label">${question.name}</span><span class="score-value">${question.score}/${question.max_score}</span></p>
									<div class="d-flex align-items-center col-12 mt-2">
										<div class="progress-bar">
											<div class="progress-fill" style="width: ${percentage}%;"></div>
										</div>
									</div>
								</div>
						
						<div id="${accordionId}" class="accordion-collapse collapse" data-bs-parent="#scorecardQuestions">
							<div class="accordion-body">
								<p class="mb-2"><strong>Context:</strong> ${question.context}</p>
								<p class="mb-2"><strong>Full Question:</strong> <span class="small-text">${question.text}</span></p>
								<p class="mb-2"><strong>Answer:</strong> ${question.answer || 'No answer provided'}</p>
							</div>
						</div>
					`;
					accordionContainer.appendChild(accordionItem);
				});
			}

			// Show the modal
			const modal = new bootstrap.Modal(document.getElementById('callDetailsModal'));
			modal.show();
		});
	});
}